var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useRenameCSS } from "../theme/Theme.js";
import { BodyShort, Detail } from "../typography/index.js";
export const InternalHeaderUser = forwardRef((_a, ref) => {
    var { className, name, description } = _a, rest = __rest(_a, ["className", "name", "description"]);
    const { cn } = useRenameCSS();
    return (React.createElement("div", Object.assign({}, rest, { ref: ref, className: cn("navds-internalheader__user", className) }),
        React.createElement("span", null,
            React.createElement(BodyShort, { size: "small", as: "div" }, name),
            description && React.createElement(Detail, { as: "div" }, description))));
});
export default InternalHeaderUser;
//# sourceMappingURL=InternalHeaderUser.js.map